import Immutable from 'immutable';

const PracticePlayRecord = Immutable.Record({
  studentId: undefined,
  activitiesCompleted: undefined,
  activitiesAmount: undefined,
  lastActivitiesCompletedDate: undefined,
});

class PracticePlay extends PracticePlayRecord { }

export default PracticePlay;



// WEBPACK FOOTER //
// ./data/PracticePlay/model/model.js